// extracted by mini-css-extract-plugin
module.exports = {"DailyChart":"DailyChart_DailyChart__2pfwU"};